import qs from 'qs'
import SuperagentApi from './superagent'

console.log(_.get(Wiz, 'globalSettings.globalConfig'), '$#$$$$$$$$$$$$$$$$$$$$$$$$$')

const baseURL = Wiz.GetModuleServer('visualization-cockpit-sm')
const superagentApi = new SuperagentApi({ baseUrl: baseURL })

const token = Wiz.AuthHooks.GetToken()
const headers = {
  Authorization: `Bearer ${localStorage.getItem('authorization') || token}`,
  'X-Wiz-Tenant-Id': JSON.parse(window.localStorage.getItem('CurrentUser'))?.TenantId || '',
}
export default class CockpitService {
  static async getDeviceStatistic() {
    const [err, res] = await superagentApi.get(
      '/api/Access-Device/get-device-statistic', { headers }
    )
    return [err, res]
  }
  static async getIotAccessRecord(payload) {
    const [err, res] = await superagentApi.get(
      `/api/iot-device-management/iot-gate-access-record/get-page-list?${qs.stringify(
        payload
      )}`,
      { headers }
    )
    return [err, res]
  }
  static async getIotBarrierAccessRecord(payload) {
    const [err, res] = await superagentApi.get(
      `/api/iot-device-management/iot-barrier-gate-access-record/get-page-list?${qs.stringify(
        payload
      )}`,
      { headers }
    )
    return [err, res]
  }
  static async getIotCameraPreview(payload) {
    const [err, res] = await superagentApi.post(
      `/api/hik-isecure-center/base/post-str-hik?${qs.stringify(payload)}`,
      { headers }
    )
    return [err, res]
  }
  static async getPlaybackUrls(data) {
    const [err, res] = await superagentApi.post(
      '/api/monitor-point/get_play_back_urls',
      { data, headers }
    )
    return [err, res]
  }
  static async getMonitorControlling(data) {
    const [err, res] = await superagentApi.post(
      '/api/monitor-point/controlling',
      { data, headers }
    )
    return [err, res]
  }
  static async getDataCategoryByCodes(payload) {
    const [err, res] = await superagentApi.get(
      `/api/data-category-management/data-categories/by-codes?${qs.stringify(
        payload
      )}`,
      { headers }
    )
    return [err, res]
  }
  static async getIotDeviceList(payload) {
    const [err, res] = await superagentApi.get(
      `/api/iot-device-management/iot-devices/get-device-with-detail-page-list-async?${qs.stringify(
        payload
      )}`,
      { headers }
    )
    return [err, res]
  }
  static async getParticipateUnitTotal() {
    const [err, res] = await superagentApi.get(
      '/api/cockpit/personnel-management/participate-statistics',
      { headers }
    )
    return [err, res]
  }
  static async getParticipatePersonRecords(payload) {
    const [err, res] = await superagentApi.get(
      `/api/cockpit/personnel-management/participate-gate-access-records?${qs.stringify(
        payload
      )}`,
      { headers }
    )
    return [err, res]
  }
  static async getUnitPersonData(payload) {
    const [err, res] = await superagentApi.get(
      `/api/cockpit/personnel-management/participate-list?${qs.stringify(
        payload
      )}`,
      { headers }
    )
    return [err, res]
  }
  static async getParticipatePersonList(data) {
    const [err, res] = await superagentApi.post(
      '/api/cockpit/personnel-management/get-participate-person-list',
      { data, headers }
    )
    return [err, res]
  }
  static async reqAnalysePerson(payload) {
    const [err, res] = await superagentApi.get(
      `/api/cockpit/personnel-management/analyse-person?${qs.stringify(
        payload
      )}`,
      { headers }
    )
    return [err, res]
  }
  static async getPersonInfo(id) {
    const [err, res] = await superagentApi.get(
      `/api/cockpit/personnel-management/get-person-info?idcard=${id}`,
      { headers }
    )
    return [err, res]
  }
  static async getFileContent(data) {
    const [err, res] = await superagentApi.get(
      `/api/file-management/files/${data.id}/content`,
      { headers }
    )
    return [err, res]
  }
  static async getHighRiskStatistics() {
    const [err, res] = await superagentApi.get(
      '/api/high-risk-assignments/get-today-statistics',
      { headers }
    )
    return [err, res]
  }
  static async getPreClassMeetingStatistics() {
    const [err, res] = await superagentApi.get(
      '/api/diy-pre-class-meeting/get-today-statistics',
      { headers }
    )
    return [err, res]
  }
  static async getHiddenDangerStatistics(payload) {
    const [err, res] = await superagentApi.get(
      `/api/hidden-danger/get-statistics?${qs.stringify(payload)}`,
      { headers }
    )
    return [err, res]
  }
  static async getDayUnitParticipate() {
    const [err, res] = await superagentApi.get(
      '/api/cockpit/personnel-management/participate-day-history',
      { headers }
    )
    return [err, res]
  }
  static async getWeekUnitParticipate() {
    const [err, res] = await superagentApi.get(
      '/api/cockpit/personnel-management/participate-week-history',
      { headers }
    )
    return [err, res]
  }
  static async getMonthUnitParticipate() {
    const [err, res] = await superagentApi.get(
      '/api/cockpit/personnel-management/participate-month-history',
      { headers }
    )
    return [err, res]
  }
}
